export default [
  {
    title: 'Accueil',
    title_en:'Home',
    route: 'home',
    icon: 'home',
  },
  {
    title: 'Mes produits',
    title_en:'My products',
    route: 'glasses',
    icon: 'glass',
  },

  {
    title: 'Codes promo',
    title_en:'Coupons',
    route: 'promotions',
    icon: 'percent',
  },
  
  {
    title: 'Paiements',
    title_en:'Payouts',
    route: 'payouts',
    icon: 'card',
  },
 
 
  
  {
    title: 'Mon profil',
    title_en:'Profile',
    route: 'profile',
    icon: 'profile',
  },
 
  // {
  //   title: 'Statistiques',
  //   route: 'analytics',
  //   icon: 'ActivityIcon',
  // },


]
